// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DesktopOutlinedSvg from "@fishx/icons-svg/es/asn/DesktopOutlined";
import FishxIcon from '../components/FishxIcon';

var DesktopOutlined = function DesktopOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DesktopOutlinedSvg
  }));
};

DesktopOutlined.displayName = 'DesktopOutlined';
export default React.forwardRef(DesktopOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DesktopOutlined.js
// module id = 2408
// module chunks = 0